import React, { Component } from "react";
import { Link } from "react-router-dom";

import "./../../../public/scss/feedComponent.scss";

import Lightbox from 'react-image-lightbox';
import 'react-image-lightbox/style.css'; // This only needs to be imported once in your app

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faTimes } from '@fortawesome/free-solid-svg-icons';

// import store from './../store';
// import PropTypes from 'prop-types';
// import { sendLoginCredentials, getParetQuestions, submitFormNow } from './../actions/formActions';
import { connect } from 'react-redux';
// import { getUserData, logOut } from './../actions/utility';

import {
    Collapse,
    Navbar,
    NavbarToggler,
    NavbarBrand,
    Nav,
    NavItem,
    NavLink,
    UncontrolledDropdown,
    Button,
    Container,
    Row,
    Media,
    Col,
    Card,
    CardTitle,
    CardSubtitle,
    CardBody,
    CardText,
    CardLink,
    Badge,
    Spinner
    // NavLink
} from "reactstrap";

import yTubeIcon from "./../../../public/images/youtubeIcon.svg";

class AppFeedComponent extends Component {

  constructor(props) {
    super(props);
    

    this.state = {
        studentInfo : this.props.studentInfo,
        studentProgarms : this.props.studentProgarms,
        showDetails : this.props.showDetails,
        showWorksheets : this.props.showWorksheets,
        isOpen : this.props.isOpen,
        photoIndex : this.props.photoIndex,
        topicVideos: this.props.topicVideos,
        topicWorkSheets: this.props.topicWorkSheets,
        hashValue: true,
        showMoreVideos: false
    };

  }

  componentWillReceiveProps(nextProps, thisProps) {
        if(nextProps.studentInfo){
            this.setState({
                studentInfo: nextProps.studentInfo
            })
        }
        if(nextProps.studentProgarms){
            this.setState({
            studentProgarms: nextProps.studentProgarms
            })
        }
        if(nextProps.showDetails){
            this.setState({
                showDetails: nextProps.showDetails
            })
        }
        if(nextProps.showWorksheets){
            this.setState({
                showWorksheets: nextProps.showWorksheets
            })
        }
        if(nextProps.isOpen){
            this.setState({
                isOpen: nextProps.isOpen
            })
        }
        if(nextProps.photoIndex){
            this.setState({
                photoIndex: nextProps.photoIndex
            })
        }
        if(nextProps.topicVideos){
            this.setState({
                topicVideos: nextProps.topicVideos
            })
        }
        if(nextProps.topicWorkSheets){
            this.setState({
                topicWorkSheets: nextProps.topicWorkSheets
            })
        }
  }

  
  componentDidMount() {
      
  }

  formatDate(date) {
    var newDate = date.split('-');
    newDate = newDate[2] + "/" + newDate[1] + "/" + newDate[0];

    return newDate;
  }

  createStars = (length, dynamicColor) => {
    let stars = [];

    // Outer loop to create parent
    for (let i = 0; i < 5; i++) {
        
        let star = <FontAwesomeIcon key={i} icon={faStar} size="1x" color={i < length ? dynamicColor : "#ccc"} />;

        stars.push(star)
    }
    return stars
  }

  showDetailsSpec = (index) => {
        var temp_array = this.state.showDetails;
        temp_array[index] = !temp_array[index];
        this.setState({
            showDetails: temp_array
        })
    }

    showWorksheetsSpec = (index) => {
        var temp_array = this.state.showWorksheets;
        temp_array[index] = !temp_array[index];
        this.setState({
            showWorksheets: temp_array
        })
    }

    openLighBox(indexForPost, indexForImage) {

        var photoIndexArray = this.state.photoIndex;
        var isOpenArray = this.state.isOpen;

        photoIndexArray[indexForPost] = indexForImage;
        isOpenArray[indexForPost] = true;

        this.setState({
            photoIndex: photoIndexArray,
            isOpen: isOpenArray
        }, () => {
            // this.reserveBackOnMobile(indexForPost);
        })

    }

    reserveBackOnMobile = (key) => {
        if(this.state.hashValue){
            window.location.hash = "currentpost" + key;
        }
        // this.setState({
        //     hashValue : "currentpost" + key
        // })

        window.onhashchange = function (event) {
            
            if(!this.state.hashValue) {
                
                window.location.hash = "currentpost" + key;
                var isOpenArray = this.state.isOpen;
                if(isOpenArray[key]){
                    isOpenArray[key] = false;
                    this.setState({ isOpen: isOpenArray })
                }

            }
            this.setState({
                hashValue : false
            })
        
        }.bind(this);

    }


  render() {

    var feed = this.props.data;
    var key = this.props.key2;
    
    const { photoIndex, isOpen } = this.state;
    
    var timeStamp = feed.ts;
    var splittedTimeStamp = timeStamp.split(" ");
    var dateTime = this.formatDate(splittedTimeStamp[0]);
    
    var tutorName = feed.teacher_name;
    var chapterName = feed.chapter_name;
    var topicName = feed.topic_name;
    var program_id = feed.feed_prog_id;
    var topic_id   = feed.feed_topic_id;
    var teacherImage   = feed.teacher_profileimage;
    if(teacherImage && teacherImage != undefined && teacherImage != '') {
        teacherImage = "https://lincolnmethod.s3.us-east-1.amazonaws.com/profileImages/" + teacherImage;
    } else {
        teacherImage = "http://info.lincolnmethod.com/wp-content/uploads/2019/12/noimage.png";
    }

    var studentName = this.state.studentInfo.user_name;
    try{
        studentName = studentName.split(' ');
        studentName = studentName[0];
    }
    catch(e){
        console.log(e);
    }
    // console.log(dateTime.getDate())

    var feed = JSON.parse(feed.feed_data);
    // console.log(feed);

    var feedImages = feed.feed_images;
    var feedDesc = feed.feed_images_desc;
    
    var performaceHtml = "";
    // if(feed.feed_performance.label == "Inadequate") {
    //     performaceHtml = studentName + "'s level of performance was " + feed.feed_performance.label + ". " + studentName + " needs to revise and practice for this activity.";
    // }
    // if(feed.feed_performance.label == "Marginal") {
    //     performaceHtml = studentName + "'s level of performance was " + feed.feed_performance.label + ". " + studentName + " needs to revise and practice for this activity.";
    // }
    // if(feed.feed_performance.label == "Adequate") {
    //     performaceHtml = studentName + "'s level of performance was " + feed.feed_performance.label + ". " + studentName + " needs a bit of improvement in this activity.";
    // }
    // if(feed.feed_performance.label == "Good") {
    //     performaceHtml = studentName + "'s level of performance was " + feed.feed_performance.label + ". " + studentName + " needs to practice some more to move ahead in this activity.";
    // }
    // if(feed.feed_performance.label == "Excellent") {
    //     performaceHtml = studentName + "'s level of performance was " + feed.feed_performance.label + ". " + studentName + " is profficient in this activity.";
    // }

    var comprehensionHtml = "";
    if(feed.feed_comprehension.label == "Inadequate") {
        comprehensionHtml = studentName + "'s understanding was " + feed.feed_comprehension.label + ". " + studentName + " needed a maximum level of tutor's assistance.";
    }
    if(feed.feed_comprehension.label == "Marginal") {
        comprehensionHtml = studentName + "'s understanding was " + feed.feed_comprehension.label + ". " + studentName + " needed a high level of tutor's assistance.";
    }
    if(feed.feed_comprehension.label == "Adequate") {
        comprehensionHtml = studentName + "'s understanding was " + feed.feed_comprehension.label + ". " + studentName + " needed a significant level of tutor's assistance.";
    }
    if(feed.feed_comprehension.label == "Good") {
        comprehensionHtml = studentName + "'s understanding was " + feed.feed_comprehension.label + ". " + studentName + " needed a low level of tutor's assistance.";
    }
    if(feed.feed_comprehension.label == "Excellent") {
        comprehensionHtml = studentName + "'s understanding was " + feed.feed_comprehension.label + ". " + studentName + " needed a minimal level of tutor's assistance.";
    }

    var willingnessHtml = "";
    var effortStars = 0;
    if(feed.feed_willingness.label == "Inadequate") {
        willingnessHtml = studentName + "'s willingness to learn was " + feed.feed_willingness.label + ". " + studentName + " displayed low level of motivation to complete this activity.";
        effortStars = 1;
    }
    if(feed.feed_willingness.label == "Marginal") {
        willingnessHtml = studentName + "'s willingness to learn was " + feed.feed_willingness.label + ". " + studentName + " displayed minimal level of motivation to complete this activity.";
        effortStars = 2;
    }
    if(feed.feed_willingness.label == "Adequate") {
        willingnessHtml = studentName + "'s willingness to learn was " + feed.feed_willingness.label + ". " + studentName + " displayed satisfactory level of motivation to complete this activity.";
        effortStars = 3;
    }
    if(feed.feed_willingness.label == "Good") {
        willingnessHtml = studentName + "'s willingness to learn was " + feed.feed_willingness.label + ". " + studentName + " displayed favorable level of motivation to complete this activity.";
        effortStars = 4;
    }
    if(feed.feed_willingness.label == "Excellent") {
        willingnessHtml = studentName + "'s willingness to learn was " + feed.feed_willingness.label + ". " + studentName + " displayed high level of motivation to complete this activity.";
        effortStars = 5;
    }


    // var badgeText = "";
    // if(feed.type == 1){
    //     color = "#008ffb";
    // }
    // else if(feed.type == 2){
    //     color = "#00e396";
    // }
    // else if(feed.type == 3){
    //     color = "#feb019";
    // }
    // else if(feed.type == 1){
    //     color = "#ff4560";
    // }
    // else if(feed.type == 1){
    //     color = "#775dd0";
    // }


    return (
        <Card id={'currentpost' + key} style={{marginBottom: '2vh', border: '1px #ccc solid', textAlign: 'left'}}>
            
            {isOpen[key] && (
                <Lightbox
                    mainSrc={"https://lincolnmethod.s3.us-east-1.amazonaws.com/Feeds/" + feedImages[photoIndex[key]]}
                    nextSrc={"https://lincolnmethod.s3.us-east-1.amazonaws.com/Feeds/" + feedImages[(photoIndex[key] + 1) % feedImages.length]}
                    prevSrc={"https://lincolnmethod.s3.us-east-1.amazonaws.com/Feeds/" + feedImages[(photoIndex[key] + feedImages.length - 1) % feedImages.length]}
                    imageCaption={feedDesc[photoIndex[key]]}
                    onCloseRequest={() => {
                        var isOpenArray = isOpen;
                        isOpenArray[key] = false;
                        this.setState({ isOpen: isOpenArray }, () => {
                            // if(isMobileBrowser()) {
                                // this.reserveBackOnMobile(key);
                            // }
                        })
                    }}
                    onMovePrevRequest={() => {
                        var photoIndexArray = photoIndex;
                        photoIndexArray[key] = (photoIndex[key] + feedImages.length - 1) % feedImages.length;
                        this.setState({
                            photoIndex: photoIndexArray
                        })
                    }}
                    onMoveNextRequest={() => {
                        var photoIndexArray = photoIndex;
                        photoIndexArray[key] = (photoIndex[key] + 1) % feedImages.length;
                        this.setState({
                            photoIndex: photoIndexArray
                        })
                    }}
                />
            )}

            <CardBody>
                <CardTitle>
                    {
                        feed.feed_subject !== '' ?
                            <h5><strong>{ studentName }</strong> did an activity in <strong>{feed.feed_subject}</strong> for <strong>{feed.feed_topic}</strong> </h5>
                        :
                            <h5><strong>{ studentName }</strong> did an activity in&nbsp;
                            <strong>
                                {
                                    this.state.studentProgarms.map(program => {
                                        if(program_id == program.progid) {
                                            return program.coursename;
                                        }
                                    })
                                }
                            </strong></h5>
                    }
                </CardTitle>
                <CardSubtitle>
                    {/* <Row>
                        <Col> */}
                        {
                            chapterName && chapterName != null ?
                            <p style={{fontSize: '12px', color: '#000', margin: 0}}>
                                Chapter: <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: chapterName}}></span>
                            </p>
                            : null
                        }
                        {
                            topicName && topicName != null ?
                            <p style={{fontSize: '12px', color: '#000', margin: 0}}>
                                Topic: <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: topicName}}></span>
                            </p>
                            : null
                        }
                        {
                            dateTime ?
                                <p style={{fontSize: '11px', color: '#565656', margin: 0, marginTop: '15px'}}>
                                    on <span style={{fontWeight: 'bold'}} dangerouslySetInnerHTML={{__html: dateTime}}></span> by <span className="initialText" dangerouslySetInnerHTML={{__html: tutorName}}></span>
                                    <Media className="tutorThumb" object src={ teacherImage } alt={ teacherImage } />
                                </p>
                            : null
                        }
                        {/* </Col>
                    </Row> */}
                </CardSubtitle>
                <hr />
                <Row style={{margin: '15px 0 0 0', textAlign: 'center'}}>
                    <Col xs={{size: 4}} style={{padding: 0}}>
                        <p style={{fontSize: '12px', margin: 0}}>
                            Performance <br/>
                            {/* <Badge style={{background: feed.feed_performance.color, padding: '8px 10px', fontSize: '12px', marginTop: '5px'}} pill > */}
                            <Badge style={{background: 
                                feed.feed_performance.label == "Inadequate" ? "#007b5f" : 
                                feed.feed_performance.label == "Marginal" ? "#54b025" : feed.feed_performance.label == "Adequate" ? "#d9dc00" : feed.feed_performance.label == "Good" ? "#ff950a" : feed.feed_performance.label == "Excellent" ? "#ff0300" : null
                                , padding: '8px 10px', fontSize: '12px', marginTop: '5px'}} pill>
                                { feed.feed_performance.label == "Inadequate" ? "A" : null }
                                { feed.feed_performance.label == "Marginal" ? "B" : null }
                                { feed.feed_performance.label == "Adequate" ? "C" : null }
                                { feed.feed_performance.label == "Good" ? "D" : null }
                                { feed.feed_performance.label == "Excellent" ? "F" : null }
                            </Badge>
                        </p>
                    </Col>
                    <Col xs={{size: 4}} style={{padding: 0}}>
                        <p style={{fontSize: '12px', margin: 0}}>
                            Understanding <br/> <Badge style={{background: feed.feed_comprehension.color, padding: '8px 10px', fontSize: '12px', marginTop: '5px'}} pill >{feed.feed_comprehension.label}</Badge>
                        </p>
                    </Col>
                    <Col xs={{size: 4}} style={{padding: 0}}>
                        <p style={{fontSize: '12px', margin: 0}}>
                            Effort <br/>
                            <Badge style={{background: 'transparent', padding: '8px 10px', fontSize: '12px', marginTop: '5px'}} pill >
                                
                                {
                                    this.createStars(effortStars, feed.feed_willingness.color)
                                }

                            </Badge>
                        </p>
                    </Col>
                </Row>
                
            </CardBody>
            
            
            <CardBody style={{padding : 0}}>
                <Row style={{margin: 0}}>
                    {
                        feedImages.map((image, key2) => {
                            
                            var gridSize = 4;
                            if(key2 == 0){
                                gridSize = 12;
                            }

                            return (
                                <Col onClick={() => this.openLighBox(key, key2)} style={{backgroundImage: 'url('+ "https://lincolnmethod.s3.us-east-1.amazonaws.com/Feeds/" + image +')'}} className="imageBox" key={key2} md={{ size: gridSize }} xs={{ size: gridSize }}>
                                    {/* <Media onClick={() => this.openLighBox(key, key2)} object src={"https://lincolnmethod.s3.us-east-1.amazonaws.com/Feeds/" + image} alt={image} /> */}
                                    {
                                    feedDesc[key2] && feedDesc[key2].length ?
                                        <p className="imageTitle">{feedDesc[key2]}</p>
                                    : null
                                    }
                                </Col>

                                // <Col className="imageBox" key={key2} md={{ size: gridSize }} xs={{ size: gridSize }}>
                                    
                                //     <img onClick={() => this.openLighBox(key, key2)} src={"https://lincolnmethod.s3.us-east-1.amazonaws.com/Feeds/" + image } />
                                    
                                //     {
                                //     feedDesc[key2] && feedDesc[key2].length ?
                                //         <p className="imageTitle">{feedDesc[key2]}</p>
                                //     : null
                                //     }
                                // </Col>
                            )
                        })
                    }
                </Row>

            </CardBody>

            <CardBody style={{textAlign: 'right'}}>
                {/* <CardText style={{fontSize: '14px'}}> */}
                <Button color="secondary" size="sm" outline onClick={e => this.showDetailsSpec(key)}>{this.state.showDetails[key] ? 'Hide' : 'Read'} tutor's notes
                    <Media className="tutorThumb" object src={ teacherImage } alt={ teacherImage } />
                </Button>
                {
                    this.state.showDetails[key] ?
                    <div>
                        <hr />
                        <ul style={{paddingLeft: '20px', fontSize: '14px', textAlign: 'left'}}>
                            {/* <li style={{marginBottom: '10px', color: feed.feed_performance.color}} dangerouslySetInnerHTML={{__html: performaceHtml}}></li> */}
                            <li style={{marginBottom: '10px', color: feed.feed_comprehension.color}} dangerouslySetInnerHTML={{__html: comprehensionHtml}}></li>
                            <li style={{marginBottom: '10px', color: feed.feed_willingness.color}} dangerouslySetInnerHTML={{__html: willingnessHtml}}></li>
                        </ul>
                    </div>
                    : null
                }
                    
                {/* </CardText> */}
                {/* <CardLink href={feed.shareUrl}>Share</CardLink> */}
            </CardBody>

            {
                this.state.topicVideos && this.state.topicVideos.length && this.state.topicVideos.map((videoList, index) => 
                    videoList[topic_id] ?
                        <CardBody key={index} style={{paddingTop: 0}}>
                            <div className="taggedVideos">
                                <hr style={{marginTop: 0}} />
                                <p style={{fontWeight: 'bold'}}>Watch these suggested videos to improve even further</p>
                                <Row className={!this.state.showMoreVideos ? "taggedVideosRow" : "taggedVideosRow opened"}>
                                {
                                    videoList[topic_id].length ?
                                        videoList[topic_id].map((video, key) => 
                                            {
                                                // console.log(video);
                                                // if(!this.state.showMoreVideos && key > 2){
                                                //     return false;
                                                // }
                                                // else{
                                                    return (
                                                        <Col key={key} md={{size: 4}} xs={{size: 12}}>
                                                            <a className="redirectAnchor" href={video.video_url} target="_new">
                                                                {/* <iframe width="100%" height="100" src={video.video_url.replace("/watch?v=", "/embed/") + "?controls=0?start=" + video.video_start} frameBorder="0"  allowFullScreen></iframe> */}
                                                                <Media object src={yTubeIcon} alt={yTubeIcon} />
                                                            
                                                                <p>
                                                                    {video.video_caption}<br />
                                                                    {/* <span style={{fontSize: '10px'}}>{video.video_url}</span> */}
                                                                </p>
                                                            </a>
                                                        </Col>
                                                    )
                                                // }
                                                
                                            }
                                        )
                                    :
                                        
                                        // !this.state.showMoreVideos && key <= 2 ?
                                        
                                            <Col key={key} md={{size: 4}} xs={{size: 12}}>
                                                <a className="redirectAnchor" href={videoList[topic_id].video_url} target="_new">
                                                    {/* <iframe width="100%" height="100" src={videoList[topic_id].video_url.replace("/watch?v=", "/embed/") + "?controls=0?start=" + videoList[topic_id].video_start} frameBorder="0"  allowFullScreen></iframe> */}
                                                    <Media object src={yTubeIcon} alt={yTubeIcon} />
                                                
                                                    <p>
                                                        {videoList[topic_id].video_caption}<br />
                                                        {/* <span style={{fontSize: '10px'}}>{videoList[topic_id].video_url}</span> */}
                                                    </p>
                                                </a>
                                            </Col>

                                        // : null
                                }
                                </Row>

                                {
                                    !this.state.showMoreVideos ?
                                        <Row>
                                            <Col md={{size : 12}}>
                                                <p style={{textDecoration: 'underline', cursor: 'pointer'}} onClick={e => this.setState({
                                                    showMoreVideos : true
                                                })}>Show all suggested videos</p>
                                            </Col>
                                        </Row>
                                    : null
                                }
                                
                            </div>
                        </CardBody>
                    : null
                )
                
            }

            {
                this.state.topicWorkSheets && this.state.topicWorkSheets.length && this.state.topicWorkSheets.map((worksheetList, index) => 
                    worksheetList[topic_id] ?

                        <CardBody key={index} style={{textAlign: 'right', background: "#e5f1ff", paddingTop: '10px', paddingBottom: '10px'}}>
                            
                            <Button color="primary" size="sm" className="worksheetsButton" onClick={e => this.showWorksheetsSpec(key)}>
                                {
                                    this.state.showWorksheets[key] ? 
                                        <FontAwesomeIcon icon={faTimes} size="1x" />
                                    :
                                        <span>Show practice worksheets&nbsp; <Badge color="warning">{ worksheetList[topic_id].length ? worksheetList[topic_id].length : 1 }</Badge></span> 
                                }
                            </Button>

                            {
                            this.state.showWorksheets[key] ?
                                <div style={{textAlign:'left'}} className="taggedWorksheets">
                                    {/* <hr /> */}
                                    <p style={{fontSize: '14px', color: '#366394'}}>Try these practice worksheets</p>
                                    <Row>
                                        <Col>
                                            <ol className="worksheetlist">
                                            {
                                                worksheetList[topic_id].length ?
                                                    worksheetList[topic_id].map((worksheet, key) => 
                                                        {
                                                            
                                                            return (
                                                                <li key={key}>
                                                                    {/* <embed width="100%" height="100" src={worksheet.link ? worksheet.link : "https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/" + worksheet.file_name} type="application/pdf"></embed> */}
                                                                    <p>
                                                                        <a href={worksheet.link ? worksheet.link : "https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/" + worksheet.file_name} target="_new">
                                                                            <span className="indexing">{key+1}</span>
                                                                            {worksheet.link ? worksheet.link_label : worksheet.file_label}<br />
                                                                            {/* <span>{worksheet.link ? worksheet.link : "https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/" + worksheet.file_name}</span> */}
                                                                        </a>
                                                                    </p>
                                                                </li>
                                                            )
                                                        }
                                                    )
                                                :   
                                                    <li>
                                                        {/* <embed width="100%" height="100" src={worksheetList[topic_id].link ? worksheetList[topic_id].link : "https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/" + worksheetList[topic_id].file_name} type="application/pdf"></embed> */}
                                                        <p>
                                                            <a href={worksheetList[topic_id].link ? worksheetList[topic_id].link : "https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/" + worksheetList[topic_id].file_name} target="_new">
                                                                {worksheetList[topic_id].link ? worksheetList[topic_id].link_label : worksheetList[topic_id].file_label}<br />
                                                                {/* <span>{worksheetList[topic_id].link ? worksheetList[topic_id].link : "https://lincolnmethod.s3.us-east-1.amazonaws.com/worksheets/" + worksheetList[topic_id].file_name}</span> */}
                                                            </a>
                                                        </p>
                                                    </li>
                                            }
                                            </ol>
                                        </Col>
                                    </Row>
                                </div>
                            : null
                            }

                        </CardBody>
                    : null
                )
                
            }

        </Card>
    )

  }
}

AppFeedComponent.propTypes = {
    
}

const mapStateToProps = state => ({
    
})

export default connect(mapStateToProps, {  })(AppFeedComponent);
